module.exports = __webpack_public_path__ + "static/media/sample-thumbnail.70e6a40b.png";